// External Imports
import { Fragment, useState } from "react";

// Internal Imports

/** ========================================================================
 * * ListLabels Component
 * This component renders a row with labels for a list.
 * ========================================================================== */

export default function ListLabels({ labels, selected, setSelected }) {
  const getClasses = (label) => {
    let classNames = "font-semibold";
    if (label.classes) classNames += ` ${label.classes}`;
    if (label.key) classNames += " cursor-pointer";
    if (selected && selected === label.key) classNames += " text-stone-200";
    else classNames += " text-stone-400";
    return classNames;
  };

  const clickHandler = (label) => {
    if (label.key) setSelected(label.key);
  };

  return (
    <Fragment>
      {labels.map((label, index) => (
        <p onClick={() => clickHandler(label)} key={index} className={getClasses(label)}>
          {label.name || label}
        </p>
      ))}
    </Fragment>
  );
}
